export default "__VITE_ASSET__BBO7Qjpp__"